// import primary libraries
import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import global components
import DefaultLayout from "../../../global/components/DefaultLayout.js.jsx";

function Forbidden({}) {
  return(
    <DefaultLayout>
      <Helmet
        title={"Forbidden | Pro-ficiency"}
      />
      <div className="flex column">
        <section className="section white-bg the-404">
          <div className="hero flex three-quarter ">
            <div className="yt-container slim">
              <h1> Whoops! <span className="light-weight">Looks like you're not authorized to view this page.</span></h1>
              <hr/>
              <h4>If you think this is an error, please contact the site/team administrator. Or you can just <a href={`${window.hubUrl}/`} className="action-link">head back home <i className="ion ion-ios-arrow-right"></i></a></h4>
            </div>
          </div>
        </section>
      </div>
    </DefaultLayout>
  )
}

export default Forbidden;



// WEBPACK FOOTER //
// modules/static/views/Forbidden.js.jsx